import script from "./big5-demo.vue?vue&type=script&setup=true&lang=js"
export * from "./big5-demo.vue?vue&type=script&setup=true&lang=js"

import "./big5-demo.vue?vue&type=style&index=0&id=a19e1886&lang=scss"

const __exports__ = script;

export default __exports__